import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PublicCategory } from '../../data/home-blocks.model';
import { resolveHomeCategoryCoverUrl } from '../../../../shared/utils/home-blocks.utils';

export interface FeaturedCategoriesBlockData {
  left: PublicCategory | null;
  right: PublicCategory | null;
}

interface PanelVm {
  id: number;
  name: string;
  link: string;
  image: string;
}

@Component({
  selector: 'app-featured-categories-block',
  imports: [RouterLink],
  templateUrl: './featured-categories-block.component.html',
  styleUrl: './featured-categories-block.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedCategoriesBlockComponent {
  readonly data = input<FeaturedCategoriesBlockData | null>(null);

  // Aplana left/right en una lista ordenada de 0..2 panels. Cualquiera puede
  // ser null (categoría borrada o sin slug); el template solo pinta los que
  // sobreviven. Si ambos caen, el bloque entero queda oculto vía `shouldRender`.
  protected readonly panels = computed<PanelVm[]>(() => {
    const value = this.data();
    if (!value) return [];
    const panels: PanelVm[] = [];
    const left = this.toPanel(value.left);
    if (left) panels.push(left);
    const right = this.toPanel(value.right);
    if (right) panels.push(right);
    return panels;
  });

  protected readonly shouldRender = computed(() => this.panels().length > 0);

  private toPanel(c: PublicCategory | null): PanelVm | null {
    if (!c || !c.slug) return null;
    return {
      id: c.id,
      name: c.name,
      link: `/tienda/${c.slug}`,
      image: resolveHomeCategoryCoverUrl(c.cover) ?? '',
    };
  }
}
